<div class="header-wrapper">
  <div class="logo-wrapper">
    <img
      [routerLink]="['/app/main', { outlets: { content: ['home'], navigation: ['sports'] } }]"
      class="logo"
      [src]="domainService.wlAssetURL + '/logo_light.png'"
      alt="" />
  </div>
  <div class="search-and-navigation">
    <app-search />
    <app-header-navigation />
  </div>
  <div class="balance-display">
    <app-balance-display />
    <div class="welcome">
      @if (showFeedbackButton) {
        <app-sentry-feedback />
      }
      <span class="welcome-text text-secondary">Welcome, {{ user?.NAME }}</span>
    </div>
  </div>
</div>
